import React from "react";
import { environmentVariables } from "../../../../config/env.config";
import { getServicesArray } from "../../../../utils/utility";
import { useTranslation } from "react-i18next";

function SubService(props) {
  let rs = props.rs;
  let service = props?.service
  const { t } = useTranslation();

  return (
    <>
      <article className="servicesName sec">
        <h3 class="sectitle" style={{color: props?.colorData?.dynamicTextHeadingColor || "#02131B"}} >{props?.colorData?.serviceHeading  || props?.colorData?.rs?.headingsObj?.service_Heading || t("Services")}</h3>

        <div className="mainservicebox">
          {/* <ul className="servesbox">
            {JSON.parse(rs?.serviceObj?.content).map((val) => (
              <li>{val?.name}</li>
            ))}{" "}
          </ul> */}
          { (rs?.serviceObj?.content || service) && (
            <ul className="servesbox">
              {getServicesArray(rs?.serviceObj?.content || service ).map((val, index) => (
                val?.name && (
                  <div className="listItem" ><li key={index} className="service-list" style={{color: props?.colorData?.dynamicCtaTextColor, background: `${props?.colorData?.dynamicCtaColor}4D`, borderColor:`${props?.colorData?.dynamicCtaColor}80` }}>
                 • {val.name}
                </li></div>
                )
              ))}
            </ul>
          )}
        </div>
      </article>
    </>
  );
}
export default SubService;
